import { isValid } from 'date-fns'

export class TimeSegment {
  hours: number = 0
  minutes: number = 0
  seconds: number = 0
  milliseconds: number = 0

  constructor(date?: Date)
  constructor(hours: number, minutes: number, seconds?: number, milliseconds?: number)
  constructor(...args) {
    switch (args.length) {
      case 0:
        break // noop
      case 1:
        this.constructWithDate.apply(this, args)
        break
      case 2:
      case 3:
      case 4:
        this.constructWithNumbers.apply(this, args)
        break
      default:
        throw new Error('Invalid arguments')
    }
  }

  static fromDate(date: Date | null) {
    return date && isValid(date) ? new TimeSegment(date) : null
  }

  static fromNumbers(hours: number, minutes: number, seconds?: number, milliseconds?: number) {
    return new TimeSegment(hours, minutes, seconds, milliseconds)
  }

  constructWithDate(date: Date) {
    this.constructWithNumbers(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds())
  }

  constructWithNumbers(hours: number, minutes: number, seconds?: number, milliseconds?: number) {
    this.hours = hours
    this.minutes = minutes
    this.seconds = seconds ?? 0
    this.milliseconds = milliseconds ?? 0
  }

  toDate(referenceDate = new Date(0)) {
    return new Date(
      referenceDate.getFullYear(),
      referenceDate.getMonth(),
      referenceDate.getDate(),
      this.hours,
      this.minutes,
      this.seconds,
      this.milliseconds,
    )
  }
}
